<template>
  <div class="spinner-container">
    <br>
    <div class="cssload-container">
      <div class="cssload-crazy-arrow" />
    </div>
    <br>
    <div class="center">
      {{ message }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'Spinner',
  props: {
    message: {
      default: '',
      type: String
    }
  }
}
</script>

<style scoped>
  .cssload-container {
    width: 100%;
    height: 27px;
    text-align: center;
  }

  .cssload-crazy-arrow {
    width: 27px;
    height: 27px;
    margin: 0 auto;
    border: 3px solid;
    border-top-left-radius: 50%;
    border-bottom-right-radius: 50%;
    border-bottom-left-radius: 50%;
    border-color: rgb(0, 187, 213);
    animation: cssload-spin 900ms infinite linear;
    -o-animation: cssload-spin 900ms infinite linear;
    -ms-animation: cssload-spin 900ms infinite linear;
    -webkit-animation: cssload-spin 900ms infinite linear;
    -moz-animation: cssload-spin 900ms infinite linear;
  }

  @keyframes cssload-spin {
    100%{ transform: rotate(360deg); transform: rotate(360deg); }
  }

  @-o-keyframes cssload-spin {
    100%{ -o-transform: rotate(360deg); transform: rotate(360deg); }
  }

  @-ms-keyframes cssload-spin {
    100%{ -ms-transform: rotate(360deg); transform: rotate(360deg); }
  }

  @-webkit-keyframes cssload-spin {
    100%{ -webkit-transform: rotate(360deg); transform: rotate(360deg); }
  }

  @-moz-keyframes cssload-spin {
    100%{ -moz-transform: rotate(360deg); transform: rotate(360deg); }
  }

  .center {
    padding: 10px;
    color: #afafaf;
    font-size: 13px;
    font-weight: 400;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Spinner.vue